export default __webpack_public_path__ + "static/media/zt.5fe28feb.svg";